import * as React from "react";
import { bindActionCreators } from "redux";
import moment from "moment";
import styles from "./index.less";
// import { Icon } from "antd";
import { Button, Modal, TextareaItem, Toast } from "antd-mobile";
import {
  makeComment,
  makePraise,
  deleteComment,
  stickComment,
} from "../../reducers/comment";
import {
  getShareConfig,
} from "../../reducers/article";
import {
  getFileList
} from "../../reducers/file";
import { connect } from "react-redux";
import { jumpToOAuth2 } from "../../utils/request";

import qs from "querystring";

import WaterMark from '../WaterMark';

const mobileCheck = function() {
  let check = false;
  (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
  return check;
};

const isMobile = mobileCheck();

export interface comment {
  id: number;
  avatar: string;
  content: string;
  article_id: string;
  nick_name: string;
  praise_num: number;
  created_at: string;
  reply_id: number;
  stick_at?: string;
  praised?: boolean;
  user_id: string;
  reply?: comment[];
}

interface AppProps {
  location?: any;
  session: { userInfo?: any, isLoggedIn: boolean };
  comment: {
    commentList: comment[];
    readInfo: {
      read_count: number;
      praise_num: number;
      praised: boolean;
      is_manager: boolean;
      allow_comment: boolean;
      need_audit: boolean;
    };
  };
  file: {
    files: Array<{
      id: string;
      name: string;
    }>,
    hasFile: boolean;
  }
  exit: () => any;

  [propName: string]: any;
}

@(connect(
  ({ session, comment, file }: AppProps) => ({
    session,
    comment,
    file,
  }),
  dispatch =>
    bindActionCreators(
      { makePraise, makeComment, deleteComment, stickComment, getFileList, getShareConfig },
      dispatch
    )
) as any)
export default class App extends React.Component<AppProps, any> {
  constructor(props: AppProps) {
    super(props);
    const {
      location: { search }
    } = props;
    this.state = {
      visible: false,
      praised: false,
      placeholder: "留言",
      replyId: undefined,
      content: "",
      isPreview: search
        ? qs.parse(search.slice(1, search.length)).preview
        : false
    };
    this.timeOut = 0;
  }
  timeOut: any;

  componentDidMount() {
    if (this.state.isPreview) {
      if (document.querySelector(".notice")) {
        document
          .querySelector(".notice")!
          .setAttribute("style", "padding-top: 48px");
      }
    }

    // if (this.props.session.isLoggedIn) {
    //   this.loadFiles();
    // }

    window.onpopstate = (event: PopStateEvent) => {
      if (event.state === null && this.state.visible) {
        this.onClose();
      }
    };

    document.body.addEventListener("touchend", e => {
      if (e.target && e.target["id"] !== "input") {
        let input = document.getElementById("input");
        if (input) {
          input.blur();
        }
      }
    });

    // if (/ztobox|ztbox|baohe/.test(navigator.userAgent.toLowerCase())) {
    //   if (global.zt && global.zt.setTitle && global.PageTitle) {
    //     global.zt.setTitle({
    //       title: global.PageTitle,
    //       bgcolor: '#ffffff'
    //     });
    //   }

    //   if (global.zt && global.zt.updateShareContent) {
    //     const shareConfig = {
    //       title: global.PageTitle || '',
    //       desc: global.Title || '',
    //       thumbImageUrl: global.AppIcon || '',
    //       webpageUrl: global.location.href,
    //       timeline: global.Title || '',
    //     };
    //     global.zt.updateShareContent(shareConfig);
    //   }
    // }

    if (this.props.session.isLoggedIn) {
      this.loadShareConfig();
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps: AppProps) {
    if (nextProps.session.isLoggedIn && !this.props.session.isLoggedIn) {
      // this.loadFiles();
      this.loadShareConfig();
    }
  }

  private loadFiles() {
    const { location } = this.props;
    const path = location.pathname.split("/");
    const articleId = path[2];

    this.props.getFileList({ articleId });
  }

  private loadShareConfig() {
    const { location } = this.props;
    const path = location.pathname.split("/");
    const articleId = path[2];

    if (/ztobox|ztbox|baohe/.test(navigator.userAgent.toLowerCase())) {
      this.props.getShareConfig({ articleId });
    }
  }

  private showTime(msgDate: string): string {
    let nowDate = moment();
    let pastDate = moment(new Date(msgDate));

    const isSameDay = nowDate.isSame(pastDate, 'day');
    const isSameYear = nowDate.isSame(pastDate, 'year');
    const isYesterday = nowDate.add('-1', 'day').isSame(pastDate, 'day');

    if (isSameDay) {
      return pastDate.format("HH:mm");
    } else if (isYesterday) {
      return `昨天 ${pastDate.format("HH:mm")}`;
    } else if (isSameYear) {
      return pastDate.format("MM-DD HH:mm")
    } else {
      return pastDate.format("YYYY-MM-DD HH:mm")
    }

    // let vDay = new Date(pastDate.getTime() + 24 * 60 * 60 * 1000);
    // let isYesterday =
    //   nowDate.getFullYear() === vDay.getFullYear() &&
    //   nowDate.getMonth() === vDay.getMonth() &&
    //   nowDate.getDate() === vDay.getDate();

    // let bDay = new Date(pastDate.getTime() + 24 * 60 * 60 * 1000 * 2);
    // let isDayBeforeYesterday =
    //   nowDate.getFullYear() === bDay.getFullYear() &&
    //   nowDate.getMonth() === bDay.getMonth() &&
    //   nowDate.getDate() === bDay.getDate();

    // if (moment().isSame(msgDate, "day")) {
    //   //同一天,显示时间
    //   result = moment(msgDate).format("HH:mm");
    // } else if (isYesterday) {
    //   result = "昨天" + moment(msgDate).format("HH:mm");
    // } else if (isDayBeforeYesterday) {
    //   result = "前天" + moment(msgDate).format("HH:mm");
    // } //显示日期
    // else {
    //   result = moment(msgDate).format("MM月DD");
    // }
    // return result;
  }

  onPraise(commentId: number): void {
    if (!commentId && this.props.comment.readInfo.praised) return;

    if (commentId === 0) {
      this.setState({
        praised: true
      });
    }

    this.props.makePraise({
      commentId: commentId || 0
    });
  }

  onReply(item: comment) {
    this.setState({
      placeholder: `回复：${item.nick_name}`,
      replyId: item.id
    });

    this.showCommentControl();
  }

  showCommentControl(direct?: boolean) {
    const {
      readInfo: { need_audit }
    } = this.props.comment;
    window.history.pushState("forward", "", "#");
    this.setState({
      visible: true
    });
    if (direct && need_audit) {
      this.setState({
        placeholder: "留言将由管理员筛选后显示，对所有人可见。"
      });
    }
  }

  onComment() {
    if (!this.state.content) {
      Toast.info("要先填写评论才可以提交哦！", 2, undefined, false);
      return;
    }
    this.props.makeComment({
      reply_id: this.state.replyId,
      content: this.state.content
    });
    window.history.back();
  }

  onClose() {
    this.setState({
      visible: false,
      placeholder: "评论",
      replyId: undefined,
      content: ""
    });
  }

  onDelete(commentId: number): void {
    Modal.alert("删除", "确定要删除吗？", [
      { text: "取消", onPress: () => { } },
      {
        text: "确定",
        onPress: () => {
          this.props.deleteComment({
            comment_id: commentId
          });
        }
      }
    ]);
  }

  onStick(id: number): void {
    this.props.stickComment({
      comment_id: id
    });
  }

  openUserInfo(userId: string) {
    if (/ztobox|ztbox|baohe/.test(navigator.userAgent.toLowerCase())) {
      if (global.zt && global.zt.openUserInfo && typeof userId !== 'undefined') {
        global.zt.openUserInfo({
          userId: userId.toString(),
          // success: () =>{
          //   Toast.info('成功');
          // },
          // fail: () =>{
          //   Toast.info('失败');
          // },
          // complete: () => {
          //   Toast.info('完成');
          // }
        });
      }
    }
  }

  renderCommentItem(item: comment) {
    const {
      readInfo: { is_manager }
    } = this.props.comment;
    return (
      <div
        key={item.id}
        className={styles.comment_item + " clearfix"}
        {...(is_manager
          ? {
            onTouchEnd: () => {
              clearTimeout(this.timeOut);
            },
            onTouchMove: () => {
              clearTimeout(this.timeOut);
              this.timeOut = 0;
              return false;
            },
            onTouchStart: () => {
              this.timeOut = setTimeout(() => {
                Modal.operation([
                  {
                    text: item.stick_at ? "取消置顶" : "置顶",
                    onPress: () => {
                      this.onStick(item.id);
                    }
                  },
                  {
                    text: "删除",
                    onPress: () => {
                      this.onDelete(item.id);
                    }
                  }
                ]);
              }, 500);
              return false;
            },
            onClick: isMobile ? undefined : () => {
              Modal.operation([
                {
                  text: item.stick_at ? "取消置顶" : "置顶",
                  onPress: () => {
                    this.onStick(item.id);
                  }
                },
                {
                  text: "删除",
                  onPress: () => {
                    this.onDelete(item.id);
                  }
                }
              ]);
            }
          }
          : {})}
      >
        <div className={styles.comment_avatar} onClick={() => {
          this.openUserInfo(item.user_id);
        }}>
          <img src={item.avatar} />
        </div>
        <div className={styles.comment_content}>
          <div className={styles.comment_nickname}>
            <div>
              <h3 onClick={() => {
                this.openUserInfo(item.user_id);
              }}>{item.nick_name}</h3>
              {item.stick_at && <span className={styles.stick}>置顶</span>}
              <span
                className={styles.praise_comment}
                onClick={
                  item.praised ? () => { } : this.onPraise.bind(this, item.id)
                }
              >
                <img
                  src={
                    item.praised
                      ? require("../../assets/heart.png")
                      : require("../../assets/heart_o.png")
                  }
                />
                <span> {item.praise_num === 0 ? "" : item.praise_num}</span>
              </span>
              {is_manager && (
                <div>
                  {/*<a className={styles.comment_delete} onClick={this.onDelete.bind(this, item.id)}>[删除]</a>*/}
                  <a
                    className={styles.comment_entry}
                    onClick={this.onReply.bind(this, item)}
                  />
                </div>
              )}
            </div>

            <span className={styles.date_stamp}>{this.showTime(item.created_at)}</span>
          </div>
          <p>{item.content}</p>

          {item.reply
            ? item.reply.map((i, index) => {
              return (
                <div key={index} className={styles.reply}>
                  <span onClick={() => {
                    this.openUserInfo(i.user_id);
                  }}>{i.nick_name} ：</span>
                  <span>{i.content}</span>
                  {is_manager && (
                    <span
                      className={styles.reply_delete}
                      onClick={this.onDelete.bind(this, i.id)}
                    >
                      [删除]
                    </span>
                  )}
                </div>
              );
            })
            : null}
        </div>
      </div>
    );
  }

  // renderFiles() {
  //   const { file: { files, hasFile } } = this.props;
  //   if (!hasFile) return null;

  //   return <div className="files">
  //     <p style={{ margin: '5px 0' }}>附件列表</p>
  //     <div>
  //       {files.map(file => <div className={styles.fileInfo} key={file.id}>
  //         <span>
  //           <Icon type="file" />
  //         </span>
  //         <div className={styles.fileName}>{file.name}</div>
  //       </div>)}
  //     </div>
  //   </div>;
  // }

  render() {
    const {
      session: { userInfo },
      comment: { commentList, readInfo },
    } = this.props;

    if (!userInfo.user_id) {
      return (
        <div key="container" className={styles.container}>
          <div className={styles.header}>
            <a
              onClick={() => {
                jumpToOAuth2();
              }}
            >
              登录
            </a>
          </div>
        </div>
      );
    }

    const previewHint = this.state.isPreview ? <div className={styles.preview_hint} key="preview-bar">预览效果，仅自己可见</div> : null;
    const waterMark = <WaterMark />;
    const controller = <div key="controller" className={styles.controller}>
      <span className={styles.read_count}>阅读 {readInfo.read_count}</span>
      <span
        className={styles.praise_count}
        onClick={this.onPraise.bind(this, 0)}
      >
        <img
          src={
            readInfo.praised || this.state.praised
              ? require("../../assets/heart.png")
              : require("../../assets/heart_o.png")
          }
        />
        {(readInfo.praise_num > 0 || this.state.praised) && (
          <span>
            {" "}
            {this.state.praised
              ? readInfo.praise_num + 1
              : readInfo.praise_num}
          </span>
        )}
      </span>
    </div>;
    const comments = readInfo.allow_comment ? <div key="container" className={styles.container}>
      <div className={styles.header}>
        <a onClick={this.showCommentControl.bind(this, true)}>写留言</a>
      </div>
      <div>{commentList.map(item => this.renderCommentItem(item))}</div>
      <div className={styles.footer}></div>
      <Modal
        visible={this.state.visible}
        maskClosable={false}
        transparent
        popup={true}
        animationType="slide-up"
        className={styles.comment_controller}
      >
        <div
          className={styles.comment_box}
          ref={ins => {
            if (ins) {
              document
                .getElementsByClassName("am-modal-wrap-popup")[0]
                .addEventListener(
                  "touchmove",
                  e => {
                    if (e.target && e.target["id"] !== "input") {
                      e.preventDefault();
                    }
                  },
                  false
                );
            }
          }}
        >
          <h1>写留言</h1>
          <TextareaItem
            id="input"
            className={styles.textArea}
            // autoFocus
            rows={5}
            count={150}
            value={this.state.content}
            onChange={value => {
              this.setState({
                content: value
                  ? value.replace(
                    /\uD83C[\uDF00-\uDFFF]|\uD83D[\uDC00-\uDE4F]/g,
                    ""
                  )
                  : ""
              });
            }}
            placeholder={this.state.placeholder}
          />
          <div className={styles.comment_control}>
            <Button
              className={styles.comment_button}
              onClick={this.onComment.bind(this)}
              type="primary"
            >
              留 言
          </Button>
            <Button
              className={styles.comment_button}
              onClick={() => {
                window.history.back();
              }}
              type="warning"
            >
              取消
          </Button>
          </div>
        </div>
      </Modal>
    </div> : null;


    return [
      previewHint,
      waterMark,
      controller,
      comments,
    ]
  }
}



// WEBPACK FOOTER //
// ./src/pages/App/index.tsx